import { BUTTON_SIZE, BUTTON_TYPE, DSButton } from '@repo/design-system/index'
import { ActivityComponentType } from '@stackflow/react'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import apis from '../../../modules/apis'
import { axiosGet } from '../../../modules/axiosHelper'
import { useCurrentUser } from '../../../modules/context/UserContext'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import { n_lesson_prep, s_upcoming_lessons } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { COLORS } from '../../../modules/vars'
import { useLessonsStack } from '../../../pages/[lang]/webview/lessons'
import LoadingSpinner from '../../common/LoadingSpinner'
import LessonOverviewExistUserModal from '../../student/new-portal/lessons/LessonOverviewExistUserModal'
import LessonOverviewNewUserModal from '../../student/new-portal/lessons/LessonOverviewNewUserModal'
import WebviewStackContainer from '../common/WebviewStackContainer'
import { Title } from './LessonPreparationActivity'

interface ILessonReminderActivity {
  params: {
    lessonId: any
  }
}

const LessonReminderActivity: ActivityComponentType = ({ params }: ILessonReminderActivity) => {
  const { useLessonsFlow } = useLessonsStack()
  const { pop, push } = useLessonsFlow()
  const { currentUser } = useCurrentUser()
  const { t } = useTranslation()

  const [data, setData] = useState(null)
  const [firstPrestudy, setFirstPrestudy] = useState(false)
  const [prepAble, setPrepAble] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const [lessonStartDate, setLessonDate] = useState('')
  const [lessonStartTime, setLessonTime] = useState('')

  const router = useAppRouter()
  const lessonId = params?.lessonId ? params.lessonId : router.query.lessonId

  useEffect(() => {
    const fetchPrestudyInfoData = async (lessonId) => {
      const response = await axiosGet(apis.lessons.upcomingPrestudyInfo(lessonId))

      if (response) {
        setData(response)
      }
    }

    const fetchPrepFirst = async () => {
      const response = await axiosGet(apis.lessons.checkFirstPrestudy())

      if (response) {
        setFirstPrestudy(response.is_first_prestudy)
      }
    }

    const fetchLessonData = async () => {
      const response = await axiosGet(apis.lessons.preparation.getV5({ lessonId: Number(params.lessonId) }))

      if (response) {
        setLessonDate(response.lesson.formatted_start_date)
        setLessonTime(response.lesson.formatted_start_time_only)
      }
    }

    const fetchData = async () => {
      try {
        setIsLoading(true)

        await fetchPrestudyInfoData(lessonId)
        await fetchPrepFirst()
        await fetchLessonData()

        setIsLoading(false)
      } catch (error) {
        // 에러 처리
        setIsLoading(false)
      }
    }

    fetchData()
  }, [])

  const handleMouseEnter = (e) => {
    e.stopPropagation()
    setShowTooltip(true)
  }

  const handleMouseLeave = (e) => {
    e.stopPropagation()
    setShowTooltip(false)
  }

  const onClickLessonStyle = () => {
    push('LessonStyleActivity', {
      lessonId: lessonId,
    })
  }

  const onClickPreparation = () => {
    push('LessonPreparationActivity', {
      lessonId: lessonId,
    })
  }

  return (
    <WebviewStackContainer
      onBack={pop}
      title={<Title lessonStartDate={lessonStartDate} lessonStartTime={lessonStartTime} />}
    >
      <div className="mt-[20px] px-[16px]">
        {isLoading ? (
          <LoadingSpinner show lg primary />
        ) : (
          <>
            {firstPrestudy ? (
              <div className="relative">
                <div className="flex flex-col space-y-12">
                  <span className="text-[24px] font-bold">{t(n_lesson_prep.overview.title)}</span>
                </div>
                <LessonOverviewNewUserModal setPrepAble={setPrepAble} />
                <div className="sticky bottom-0 flex w-full flex-row justify-center space-x-[8px] bg-white py-[11px]">
                  <DSButton
                    size={BUTTON_SIZE.LG}
                    type={BUTTON_TYPE.SOLID}
                    className={classNames('border-[1.5px] text-white')}
                    customBorderColor={COLORS.PURPLE500}
                    onClick={onClickPreparation}
                  >
                    <div className="font-medium">{t(s_upcoming_lessons.prepare_btn)}</div>
                  </DSButton>
                </div>
              </div>
            ) : (
              <div className="relative">
                <div className="flex">
                  <span className="text-[24px] font-bold">{t(n_lesson_prep.overview.title2)}</span>
                </div>
                <LessonOverviewExistUserModal data={data} currentUser={currentUser} />
                <div className="sticky bottom-0 flex w-full flex-row justify-center space-x-[8px] bg-white py-[11px]">
                  <DSButton
                    size={BUTTON_SIZE.LG}
                    type={BUTTON_TYPE.SOLID}
                    className={classNames('border-[1.5px] text-white')}
                    onClick={onClickPreparation}
                  >
                    <div className="font-medium">{t(s_upcoming_lessons.prepare_btn)}</div>
                  </DSButton>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </WebviewStackContainer>
  )
}

export default LessonReminderActivity
